module.exports = __webpack_public_path__ + "static/mappic-a2d522daac74f6db87faf582a352081c.jpg";